export interface SessionDomainLabel {
  label: string;
  isProxy: boolean;
  title: string;
}

interface SessionDomainInput {
  hostname?: string | null;
  siteCountry?: string | null;
  language?: string | null;
}

function tldFromHostname(hostname: string): string | null {
  const host = hostname
    .trim()
    .toLowerCase()
    .replace(/^www\./, '');
  if (host.endsWith('.co.uk')) return '.co.uk';
  const match = host.match(/(\.[a-z]{2,})$/);
  return match ? match[1] : null;
}

export function resolveSessionDomainLabel(
  input: SessionDomainInput | null | undefined,
): SessionDomainLabel | null {
  if (!input) return null;

  const hostname = typeof input.hostname === 'string' ? input.hostname.trim() : '';
  if (hostname) {
    const tld = tldFromHostname(hostname);
    if (tld) {
      return { label: tld, isProxy: false, title: hostname };
    }
  }

  const country = typeof input.siteCountry === 'string' ? input.siteCountry.trim() : '';
  if (country) {
    return {
      label: `${country.toUpperCase()}?`,
      isProxy: true,
      title: 'Härlett från land — domän saknas',
    };
  }

  const language = typeof input.language === 'string' ? input.language.trim() : '';
  if (language) {
    return {
      label: `${language.toLowerCase()}?`,
      isProxy: true,
      title: 'Härlett från språk — domän saknas',
    };
  }

  return null;
}
